/**
 * @ngdoc services
 * @memberof mercury.modules.qa.idealpos
 * @name ItemsalesReport
 * @description Data access service for Bepoz Product Summary
 */
angular.module('mercury.modules.qa.idealpos.itemsalesreport')
.factory('ItemsalesReport', ["$q", "$resource", "settings", function($q, $resource, settings) {
  var Report = $resource(settings.apiHost + '/r/PosQaIdealposItemSalesReport');

  /**
   * Get a financial report for a report period
   *
   * @memberof ProductSummary
   * @param  {String} start start of the report period
   * @param  {String} end end of the report period
   * @return {Object} promise
   */
  function getReport(start, end) {
    return Report.query({start: start, end: end}).$promise;
  }

  return {
    getReport: getReport
  };
}]);
